import { setRoute } from '../../routes/actions/set';

export function request(id) {
    id = parseInt(id, 10);

    return (dispatch, getState) => {
        const state = getState();

        if (id == state.routes.getIn([ 'events', 'value' ])) {
            dispatch(setRoute('events'));
        }

        dispatch({
            type: 'EVENTS_CLOSE_REQUEST',
            id
        });
    };
}
